import { useEffect, useState } from "react";
import Sidenav from "../../components/sidenav/Sidenav";
import Header from "../../components/header/Header";
import withAuth from "../../hocs/withAuth";
import ShowBgImage from "../../components/showbgimage/ShowBgImage";
import InputBox from "../../components/input/InputBox";
import validations from "../../validarions/clinicDetails.validation";

import { Wrapper, ClinicSection, ClinicSectionChild, FormContainer, Grid } from "./ClinicDetails.styles";
import {
  deleteProfile,
  getClinicDetails,
  updateClinicDetails,
} from "../../services/clinic-detail.service";
import { useToast } from "../../contexts/ToastContext";
import { getDataFromLocalStorage, resetProperty } from "../../utils/localStorage";
import useLoader from "../../hooks/useLoader";
import ActionModal from "../../components/gradingmodal/ActionModal";

type formField = {
  value: string;
  error: string;
};

interface IFormFieldValue {
  name: formField;
  phone: formField;
  street: formField;
  state: formField;
  city: formField;
  zipcode: formField;
  email: formField;
}

const formItems = [
  {
    id: "name",
    labelName: "Clinic Name",
    placeHolderName: "Clinic Name",
    type: "text",
    fullWidth: true,
  },
  {
    id: "city",
    labelName: "City",
    placeHolderName: "Name of city",
    type: "text",
  },
  {
    id: "state",
    labelName: "State",
    placeHolderName: "Name of state",
    type: "text",
  },
  {
    id: "zipcode",
    labelName: "Zip Code",
    placeHolderName: "Zip Code",
    type: "text",
  },
  {
    id: "street",
    labelName: "Street",
    placeHolderName: "Name of steet",
    type: "text",
  },
  {
    id: "phone",
    labelName: "Phone Number",
    placeHolderName: "Phone",
    type: "text",
  },
  {
    id: "email",
    labelName: "Email Address",
    placeHolderName: "Email",
    type: "email",
  },
];

const ApiValues = {
  name: "clinicName",
  email: "email",
  phone: "phoneNumber",
  city: "cityName",
  state: "stateName",
  zipcode: "zipCode",
  street: "street",
};

function ClinicDetails() {
  const { name, street, zip_code, city_name, state_name, phone_number, email } =
    getDataFromLocalStorage("clinicData") || {};

  const [formFields, setFormFields] = useState<IFormFieldValue>({
    name: { value: name ? name : "", error: "" },
    phone: {
      value: phone_number ? "+1 " + phone_number : "",
      error: "",
    },
    street: { value: street ? street : "", error: "" },
    state: { value: state_name ? state_name : "", error: "" },
    city: { value: city_name ? city_name : "", error: "" },
    zipcode: { value: zip_code ? zip_code : "", error: "" },
    email: { value: email ? email : "", error: "" },
  });

  const [file, setFile] = useState<string | null>("");
  const [fileMetaInfo, setFileMetaInfo] = useState<File | null>(null);

  const { loading, startLoading, stopLoading } = useLoader();
  const { image_url } = getDataFromLocalStorage("clinicData") || {};
  const [openModal, setOpenModal] = useState(false);
  const toast = useToast();

  const onFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const length = event.target.files?.length;
    if (length && length > 0) {
      if (event.target.files && event.target.files[0]) {
        setFile(URL.createObjectURL(event.target.files[0]));
        setFileMetaInfo(event.target.files[0]);
      }
    }
  };

  const changeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const errorMessage = validations[name as keyof typeof validations](value);
    setFormFields((prev) => ({
      ...prev,
      [name]: {
        value,
        error: errorMessage,
      },
    }));
  };

  const sanitizeFormValues = () => {
    let data = {};
    for (const key in formFields) {
      const keyApi = ApiValues[key as keyof IFormFieldValue];
      switch (key) {
        case "phone":
          data = { ...data, phoneNumber: formFields.phone.value.replace("+1", "").trim() };
          break;

        default:
          data = { ...data, [keyApi]: formFields[key as keyof IFormFieldValue].value };
          break;
      }
    }

    return data;
  };

  const sendDataToServer = () => {
    // TODO: Leave this commented code until solve the img uplading
    // const formData = new FormData();
    // fileMetaInfo && formData.append("file", fileMetaInfo);

    const data = sanitizeFormValues();

    updateClinicDetails(
      data,
      toast?.displayMessage,
      () => {
        getClinicDetails(toast?.displayMessage);
      },
      startLoading,
      stopLoading
    );
  };

  const handleSubmit = () => {
    let hasError = false;
    for (let key in formFields) {
      if (Boolean(formFields[key as keyof typeof formFields].error)) {
        hasError = true;
        break;
      }
    }

    for (let key in formFields) {
      const value = formFields[key as keyof typeof formFields].value;
      const errorMessage = validations[key as keyof typeof validations](value);
      if (Boolean(errorMessage)) hasError = true;
      setFormFields((prev) => ({
        ...prev,
        [key]: {
          value,
          error: errorMessage,
        },
      }));
    }

    if (!hasError) {
      sendDataToServer();
    }
  };

  const resetFile = () => {
    setFile(null);
    setFileMetaInfo(null);
  };

  const clinicImageDeleteHandler = () => {
    image_url && deleteProfile(toast?.displayMessage);
    resetFile();
    resetProperty("clinicData", "image_url");
    setOpenModal(false);
  };

  useEffect(() => {
    getClinicDetails(toast?.displayMessage);
  }, []);

  return (
    <Wrapper>
      <Sidenav />
      <ClinicSection>
        <ClinicSectionChild>
          <Header text={"Conceptions"} showBtn={true} handleClick={handleSubmit} loading={loading} />
          <ShowBgImage
            file={typeof file === "string" ? file : ""}
            onFileChange={onFileChange}
            openModal={() => setOpenModal(true)}
          />
          <FormContainer>
            {formItems.map((formItem, idx) => (
              <Grid fullWidth={Boolean(formItem.fullWidth)} key={idx}>
                <InputBox
                  value={formFields[formItems[idx].id as keyof typeof formFields].value}
                  handler={changeHandler}
                  style={{
                    width: Boolean(formItem.fullWidth) ? "98%" : "95%",
                  }}
                  error={formFields[formItems[idx].id as keyof typeof formFields].error}
                  {...formItem}
                />
              </Grid>
            ))}
          </FormContainer>
        </ClinicSectionChild>
      </ClinicSection>
      {openModal && (
        <ActionModal
          onCloseModal={() => setOpenModal(false)}
          text={"Are you sure you want to delete"}
          firstBtnText={"Delete"}
          secondBtnText={"No, go back"}
          isDelete={true}
          actionHandler={clinicImageDeleteHandler}
        />
      )}
    </Wrapper>
  );
}

export default withAuth(ClinicDetails);
